import { gql } from '@apollo/client';

export const queryName = 'memberInfo';
export const currentMemberName = 'CurrentMember';
export const currentMember = gql`
	fragment ${currentMemberName} on Member {
		id
		email
		stateOfResidence {
			abbreviation
			gahtEstrogen
			gahtTestosterone
			virtualHealthcare
			mentalHealthTherapy
			mentalHealthMedication
			adhd
		}
		displayNameFirst
		hasValidSsn
		b2bCustomer {
			name
			id
		}
	}
`;
